import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoKona from "../kona/InfoKona";
const Footer = lazy(() => import('../footer/Footer'));
function Kona() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai Tucson, tu compañero ideal, 100% Europeo. Galardonado por su seguridad, rendimiento, equipamiento, tecnología, amplitud y confort. Un SUV premium"
        />
        <meta
          name="keywords"
          content="SUV, Hyundai, Hyundai Kona, Kona, seguro, amplio, alto, tecnológico, confortable"
        />
        <title>Hyundai Kona</title>
      </Helmet>
      <Menu />
      <InfoKona />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Kona;